var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "51717951-EB51-498C-87ED-20E5B191F8C0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-MVP/22",
    transform: "translate(-568.000000, -759.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selectable-Card-Copy-2",
    transform: "translate(508.000000, 726.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(21.000000, 18.887324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_Shipping",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2172294,31.2785209 C45.0059028,31.0675705 44.7241342,30.9972537 44.4426371,31.1378873 C43.1045678,31.6301049 41.6258555,31.911101 40.2173139,31.911101 C33.5271182,31.911101 28.0348016,26.4982286 28.0348016,19.7502708 C28.0348016,18.2738891 28.3165703,16.8681556 28.8093939,15.5324678 C28.8798353,15.2512006 28.8093939,14.9702346 28.6685096,14.7592541 C28.457183,14.5483037 28.1754144,14.4779869 27.8939173,14.6186205 C22.6122633,16.5869035 19.0909091,21.6481919 19.0909091,27.3420754 C19.0909091,34.7935777 25.1471554,40.9090909 32.6821139,40.9090909 C38.3159788,40.9090909 43.4566881,37.3941546 45.4282541,32.1217501 C45.4984012,31.7701661 45.4282541,31.4889064 45.2169276,31.2782648 L45.2172294,31.2785209 Z M32.9695144,39.0906551 C26.3463654,39.0906551 20.9090909,33.7224744 20.9090909,27.0302316 C20.9090909,22.498572 23.4887188,18.3856583 27.3927823,16.3636364 C27.1138374,17.409381 26.974365,18.4551256 26.974365,19.5706364 C26.974365,26.9606149 32.9699178,33.025635 40.4293636,33.025635 C41.5448744,33.025635 42.590619,32.8861626 43.6363636,32.6072177 C41.6143417,36.5112812 37.5010546,39.0909091 32.9697684,39.0909091 L32.9695144,39.0906551 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvening);
export default __webpack_public_path__ + "static/media/Evening.65425b4c49b73920b8dcb5a7e63a2175.svg";
export { ForwardRef as ReactComponent };